import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";

const SUB_TABS = [
  { id: "omr", path: "/mcqs/omr", label: "Check" },
  { id: "formatting", path: "/mcqs/formatting", label: "Formatting" },
];

function getActiveSubTab(pathname) {
  if (pathname.includes("/formatting")) return "formatting";
  return "omr";
}

export default function MCQsLayout() {
  const location = useLocation();
  const activeSubTab = getActiveSubTab(location.pathname);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: 0,
      position: "absolute",
      top: "var(--header-height)",
      left: 0,
      right: 0,
      bottom: 0,
      height: "calc(100vh - var(--header-height))"
    }}>
      <div className="subnav">
        {SUB_TABS.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`subnav-tab ${activeSubTab === tab.id ? "active" : ""}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}
